<template>
  <div
    id="app"
    hb-loading-bg="#181817"
    v-hb-loading.fullscreen.lock="isPageLoading"
    v-report.visit
  >
    <hb-share-header
      v-if="!isInApp && !isPageLoading"
      title="小黑盒"
      desc="高能玩家聚集地"
      :noPadding="false"
      pageKey="tga_2024"
    />

    <img class="header-image" v-src="imageList.header"/>

    <div class="rule-container">
      <div class="title-line">
        <div class="title">全部获奖结果</div>
        <!-- <div class="rule-jump" @click="showRuleModal = true">
          规则说明
          <hb-icon common-arrow-right-line></hb-icon>
        </div> -->
        <div class="subscribe-container">
          <div class="subscribe-text">订阅</div>
          <hb-switch v-model="hasSubscribed" @open="handleSubscribe(true)" @close="handleSubscribe(false)"></hb-switch>
        </div>
      </div>
      <div class="title-desc">
        小黑盒票数
        <span>「同步计入最终TGA票选结果」</span>
      </div>
    </div>


    

    <div class="main-category-container">
      <div
        class="main-category-item"
        v-for="category in mainCategoryList"
        :key="category.value"
        :class="{ active: category.value === activeMainCategoryKey }"
        @click="activeMainCategoryKey = category.value"
      >
        {{ category.label }}
      </div>
    </div>

    <div class="category-container">
      <CptGameAward
        v-for="award in activeAwardList"
        :award="award"
        :key="award.title"
        @vote="handleShowVoteModal"
        @result="handleShowResultModal"
      ></CptGameAward>
    </div>

    <div class="screenshot-wrapper" ref="screenshot" v-if="isScreenshot">
      <img class="unite-icon" v-src="imageList.uniteIcon" />
      <div class="title-wrapper">
        <img class="icon left" v-src="imageList.icon" />
        <div class="text">2024游戏大选</div>
        <img class="icon right" v-src="imageList.icon" />
      </div>
      <div class="subtitle-wrapper">
        我心中的<span>{{ votingAward.title }}</span
        >是
      </div>
      <div class="selected-game-wrapper">
        <div class="game-outer-box">
          <div class="game-inner-box">
            <div class="game-image">
              <img class="image" v-src="targetVoteGame.img" alt="" />
            </div>
          </div>
        </div>
        <div class="game-name">
          {{ targetVoteGame.name }}
        </div>
      </div>
      <div class="rule-desc">
        来小黑盒投票,<span>选票计入官方</span>影响最终投票结果<br />
        还有机会抽取年度游戏CDK
      </div>
      <CptFooter></CptFooter>
    </div>

    <CptFooter></CptFooter>

    <!-- <CptFooterActivity
      :awardList="activeAwardList"
      @vote="handleShowVoteModal"
      @result="handleShowResultModal"
    ></CptFooterActivity> -->
    <!-- 规则弹窗 -->
    <hb-modal class="rule-modal" :visible.sync="showRuleModal" :lock="true">
      <div class="rule-wrapper">
        <div class="rule-title">规则说明</div>
        <div class="rule-list">
          <div class="rule-item" v-for="(rule, index) in rules" :key="index">
            <div class="rule-index">{{ index + 1 }}.</div>
            <div class="rule-content">{{ rule }}</div>
          </div>
        </div>
      </div>
      <template slot="footer">
        <hb-button
          type="primary"
          size="large"
          text="我已知晓"
          @click="showRuleModal = false"
        ></hb-button>
      </template>
    </hb-modal>
    <!-- 投票弹窗 -->
    <hb-modal
      v-if="votingAward"
      class="vote-modal"
      :visible.sync="showVoteModal"
      :lock="true"
      @close="handleCloseVoteModal"
    >
      <div class="vote-container">
        <div class="vote-header">
          <div class="title">{{ votingAward.title }}</div>
          <div class="sub-title">{{ votingAward.desc }}</div>
          <!-- <div class="desc">请为下方的一个选项投票，后续不可更改</div> -->
          <div class="btn-close" @click="handleCloseVoteModal">
            <hb-icon common-close></hb-icon>
          </div>
        </div>
        <div class="vote-content">
          <CptMessageContainer
            v-if="showVoteModal && isInApp"
            type="vote"
            :channelId="votingAward.channel_id"
            @jump="handleJumpConfirmDialog"
          ></CptMessageContainer>
          <div class="content-scroll-wrapper" ref="vote-outer">
            <div class="game-list" ref="vote-inner">
              <CptGameSelector
                v-for="game in votingAward.items"
                :key="game.key"
                :game="game"
                :isSelected="activeVoteGameKey == game.key"
                @click.native="handleSelectGame(game)"
              ></CptGameSelector>
            </div>
            <div class="game-list-bottom"></div>
          </div>
          <div class="bottom-mask"></div>
        </div>
      </div>
      <template slot="footer">
        <div class="vote-btn" @click="openConfirmModal">
          {{ votingAward.my_result ? '分享抽取年度游戏CDK' : '关闭' }}
        </div>
      </template>
    </hb-modal>

    <!-- 结果弹窗 -->
    <hb-modal
      v-if="resultAward"
      class="result-modal"
      :visible.sync="showResultModal"
      :lock="true"
    >
      <div class="result-container">
        <div class="result-header">
          <div class="title">{{ resultAward.title }}</div>
          <div class="sub-title">{{ resultAward.content }}</div>
          <div class="btn-close" @click="handleCloseResultModal">
            <hb-icon common-close></hb-icon>
          </div>
        </div>
        <div class="result-content">
          <CptMessageContainer
            v-if="showResultModal && isInApp"
            type="result"
            :channelId="resultAward.channel_id"
            @jump="handleJumpResultChat"
          ></CptMessageContainer>
          <div class="content-scroll-wrapper" ref="vote-outer">
            <CptGameInfo :game="tgaAwardGame"></CptGameInfo>
            <div class="subtitle">提名作品</div>
            <div class="game-list" ref="vote-inner">
              <CptGameSelector
                v-for="game in resultAward.items"
                :key="game.id"
                :game="game"
                :isNominee="true"
              ></CptGameSelector>
              <div class="game-list-bottom"></div>
            </div>
          </div>
          <div class="bottom-mask"></div>
        </div>
      </div>
      <template slot="footer">
        <div class="chat-btn" @click="handleJumpResultChat">
          {{ '前往官方语音频道' }}
        </div>
      </template>
    </hb-modal>

    <!-- 确认投票弹窗 -->
    <hb-dialog
      class="vote-dialog"
      :visible.sync="showVoteConfirmDialog"
      title="确认投票"
      :desc="`为${targetVoteGame.name}投票`"
    >
      <template slot="footer">
        <hb-button
          type="cancel"
          text="取消"
          @click="showVoteConfirmDialog = false"
        ></hb-button>
        <hb-button type="confirm" text="确认" @click="confirmVote"></hb-button>
      </template>
    </hb-dialog>

    <!-- 跳转语音弹窗 -->
    <hb-dialog
      class="chat-dialog"
      :visible.sync="showJumpConfirmDialog"
      title="前往官方语音频道"
      :desc="jumpConfirmTips"
    >
      <template slot="footer">
        <hb-button
          type="cancel"
          text="取消"
          @click="showJumpConfirmDialog = false"
        ></hb-button>
        <hb-button type="chat" text="确认" @click="jumpChat"></hb-button>
      </template>
    </hb-dialog>
  </div>
</template>

<script>
import { getData, vote, getSubscribeState, subscribePush } from '_api/activity/tga-2024';
import {
  getUrlParam,
  getParams,
  executeProtocol,
  showMessage,
  geVersion,
} from '_lib/utils';
import { chatroomInfo } from '../assets/js/chatroom';
import { openWindow } from '../assets/js/jump';
import rules from '../assets/js/rule.json';
import CptGameAward from './components/cpt-game-award.vue';
import CptGameSelector from '../components/cpt-game-selector.vue';
import CptFooterActivity from './components/cpt-footer-activity.vue';
import CptFooter from '../components/cpt-footer.vue';
import CptGameInfo from './components/cpt-game-info.vue';
import CptMessageContainer from './components/cpt-message-container.vue';
export default {
  components: {
    CptGameAward,
    CptFooterActivity,
    CptGameSelector,
    CptGameInfo,
    CptMessageContainer,
    CptFooter,
  },
  data() {
    return {
      showNav: getUrlParam('source') != 'tab',
      isPageLoading: true,
      querys: getParams(),
      isScreenshot: false,
      isInApp: this.$hb_env.is_inapp,
      hasSubscribed: false,

      // 总数据
      voteList: [],
      shareInfo: {},

      mainCategoryList: [
        { label: '游戏类', value: 'game' },
        { label: '电竞类', value: 'esports' },
        { label: '制作类', value: 'production' },
      ],
      activeMainCategoryKey: 'game',

      showRuleModal: false,
      rules,

      // 投票弹窗
      showVoteModal: false,
      votingAward: {},
      activeVoteGameKey: -1,
      targetVoteGame: {},

      //结果弹窗
      showResultModal: false,
      resultAward: {},
      tgaAwardGame: {},

      //确认投票弹窗
      showVoteConfirmDialog: false,

      //确认跳转弹窗
      showJumpConfirmDialog: false,
      jumpConfirmTips: '参与讨论随机掉落惊喜奖品',
      isOnline: window.location.origin.includes('xiaoheihe.cn'),
      chatroomInfo,

      imageList: {
        uniteIcon:
          'https://imgheybox.max-c.com/oa/2024/11/07/5b03f4a6289deafb29d167e6147c22bc.png',
        headerBG:
          'https://imgheybox.max-c.com/oa/2024/11/07/c1e95691d27284da063a96d95dd69c1a.png',
        header:
          'https://imgheybox.max-c.com/oa/2024/12/13/859bdf3f5715544de561b94e3ac64f64.png',
        anniversary:
          'https://imgheybox.max-c.com/oa/2024/11/06/da42e105050859850d9082888d324f48.png',
        icon: 'https://imgheybox.max-c.com/oa/2024/11/12/50d0a5a0e5d94eca8d1f0cb866ead86c.png',
      },
    };
  },
  created() {
    if (this.querys.heybox_id == -1) {
      executeProtocol({
        protocol_type: 'login',
      });
    }
    this.getHomeData();
  },
  computed: {
    activeMainCategory() {
      return (
        this.voteList.find((item) => item.key == this.activeMainCategoryKey) ||
        {}
      );
    },
    activeAwardList() {
      return this.activeMainCategory.items || [];
    },
  },
  methods: {
    async getHomeData() {
      let { data } = await getData({
        act_id: this.querys.act_id,
      });
      let { result, status } = data;
      if (status == 'ok') {
        this.voteList = result.vote_list || [];
        this.shareInfo = result.share_info || {};
        this.mainCategoryList = this.voteList.map((item) => {
          return {
            value: item.key,
            label: item.title,
          };
        });
        this.activeMainCategoryKey = this.voteList[0]?.key;
        if (!result.is_login) {
          executeProtocol({
            protocol_type: 'login',
          });
        } else {
          this.getSubscribeState()
        }
      }
      this.isPageLoading = false;
    },
    async getSubscribeState() {
      let { data } = await getSubscribeState()
      let { status, result } = data
      if (status == 'ok') {
        this.hasSubscribed = result.act_push_state
      }
    },
    handleShowVoteModal(award) {
      if (!this.isInApp) {
        this.openInApp();
        return;
      }
      this.showVoteModal = true;
      this.votingAward = award;
      if (this.votingAward.my_result) {
        this.activeVoteGameKey = this.votingAward.my_result;
      }
    },
    handleCloseVoteModal() {
      this.showVoteModal = false;
      this.activeVoteGameKey = -1;
      this.targetVoteGame = {};
    },
    handleSelectGame(game) {
      // if (this.votingAward.my_result) {
      //   return;
      // }
      // if (this.activeVoteGameKey !== game.key) {
      //   this.activeVoteGameKey = game.key;
      //   this.targetVoteGame = game;
      // } else {
      //   this.activeVoteGameKey = -1;
      //   this.targetVoteGame = {};
      // }
    },
    openConfirmModal() {
      this.handleCloseVoteModal()
      // if (this.votingAward.my_result) {
      //   this.screenshotShare();
      //   return;
      // }
      // if (this.is_share) {
      //   this.openInHeybox();
      //   return;
      // }
      // if (!this.targetVoteGame?.key) {
      //   showMessage('failed', '请选择一项后投票');
      //   return;
      // }

      // this.showVoteConfirmDialog = true;
    },
    handleShowResultModal(award) {
      if (!this.isInApp) {
        this.openInApp();
        return;
      }
      this.resultAward = award;
      if (this.resultAward.tga_result) {
        this.tgaAwardGame = this.resultAward.items.find(
          (item) => item.key == award.tga_result,
        );
      }
      this.showResultModal = true;
    },
    handleCloseResultModal() {
      this.showResultModal = false;
      this.tgaAwardGame = {};
      this.resultAward = {};
    },
    handleJumpConfirmDialog() {
      this.jumpConfirmTips = '参与讨论随机掉落惊喜奖品';
      this.showJumpConfirmDialog = true;
    },
    handleJumpResultChat() {
      this.jumpConfirmTips = '讨论年度游戏结果';
      this.showJumpConfirmDialog = true;
    },
    jumpChat() {
      this.showJumpConfirmDialog = false;
      if (this.isInApp && geVersion('1.3.298')) {
        let chatParams = {
          mini_program: '1',
          mini_program_id: '207',
        };
        if (this.isOnline) {
          chatParams = {
            ...chatParams,
            ...this.chatroomInfo.online,
          };
        } else {
          chatParams = {
            ...chatParams,
            ...this.chatroomInfo.test,
          };
        }
        executeProtocol({
          protocol_type: 'openRouterPath',
          path: '/flutter/heybox_voice',
          need_login: 1,
          params: chatParams,
        });
      } else {
        showMessage('failed', '请升级到最新版本小黑盒查看');
      }
    },

    //确认投票
    async confirmVote() {
      if (this._voteLock) return;
      this._voteLock = true;
      let { data } = await vote({
        act_id: this.querys.act_id,
        key: this.targetVoteGame.key,
        sp_type: 'tga2024',
      });
      let { status } = data;
      if (status == 'ok') {
        showMessage('ok', '投票成功');
        this.showVoteConfirmDialog = false;

        let targetAward = this.activeAwardList.find(
          (a) => a.sub_title == this.votingAward.sub_title,
        );
        if (targetAward) {
          this.$set(targetAward, 'my_result', this.targetVoteGame.key);
          let voteGame = targetAward.items.find(
            (g) => g.key == this.targetVoteGame.key,
          );
          voteGame && this.$set(voteGame, 'num', voteGame.num + 1);
          this.screenshotShare();
        }
      }
      this._voteLock = false;
    },

    // 截图分享
    screenshotShare() {
      this.isScreenshot = true;
      this.targetVoteGame = this.votingAward.items.find(
        (g) => g.key == this.votingAward.my_result,
      );

      if (!window.screenshotCallback) {
        window.screenshotCallback = () => {
          this.isScreenshot = false;
        };
      }

      this.$nextTick(() => {
        const useV2 = geVersion('1.3.291');
        // const screenWidth =
        //   document.body.clientWidth || document.documentElement.clientWidth;
        const rects = [];
        const screenshotDom = this.$refs['screenshot'];
        let domRect = screenshotDom.getBoundingClientRect();
        rects.push([
          {
            top: domRect.top,
            left: domRect.left,
            width: domRect.width,
            height: domRect.height - 1,
          },
        ]);
        const hashtags = ['TGA2024'];
        const jsCallbackFunc = 'screenshotCallback()';
        const protocolV1 = {
          protocol_type: 'screenShotShare',
          rects,
          qr_code: 0,
          jsCallbackFunc,
          delay: 300,
          hashtags,
          src: this.shareInfo.src,
          share_title: this.shareInfo.share_title,
          share_url: this.shareInfo.share_img,
          act_id: this.shareInfo.share_act_id,
        };
        const protocolV2 = {
          protocol_type: 'screenShotShareV2',
          custom: '1',
          img_info: {
            rects,
            delay: 500,
          },
          upload_info: {
            jsCallbackFunc,
          },
          share_info: {
            post_config: {
              hashtags,
            },
            report: {
              src: this.shareInfo.src,
            },
          },
        };
        if (this.targetVoteGame?.topic_info) {
          protocolV1.topic_info = this.targetVoteGame.topic_info;
          protocolV2.share_info.post_config.topic_infos = [
            this.targetVoteGame.topic_info,
          ];
        }
        executeProtocol(useV2 ? protocolV2 : protocolV1);
      });
    },
    openInApp() {
      openWindow('/activity/tga_2024/home', {
        act_id: this.querys.act_id,
      });
    },
    async handleSubscribe(flag) {
      let { data } = await subscribePush({}, {
        heybox_id: this.querys.heybox_id,
        op: flag ? 1 : 0,
      });
      if(data.status == 'ok') {
        showMessage('ok', flag ? '订阅成功' : '取消成功')
      }
    }
  },
};
</script>

<style lang="less">
@import '~_style/common.css';
@import '../assets/css/common.less';
@import './assets/css/font.css';
#app {
  padding-bottom: 88px;
  position: relative;
  max-width: 480px;
  margin: auto;
  .header-image {
    width: 100%;
    max-width: 480px;
    margin-bottom: 10px;
  }
  .rule-container {
    padding: 0 14px;
    .title-line {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 25px;
      .title {
        color: #e0e0e0;
        font-family: 'PingFang SC';
        font-size: 18px;
        font-weight: 500;
      }
      .rule-jump {
        margin-left: 12px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        color: #8c9196;
        font-family: 'PingFang SC';
        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
        i {
          margin-left: 1px;
          font-size: 10px;
        }
      }
    }
    .title-desc {
      margin-top: 4px;
      height: 16px;
      color: rgba(255, 255, 255, 0.6);
      font-family: 'PingFang SC';
      font-size: 12px;
      font-weight: 300;
      line-height: 16px;
      span {
        font-weight: 600;
      }
    }
    .subscribe-container {
      margin-left: auto;
      display: flex;
      flex-direction: row;
      align-items: center;
      .subscribe-text {
        color: #FFF;
        text-align: right;
        font-family: "PingFang SC";
        font-size: 12px;
        font-weight: 500;
        line-height: 17px;
        margin-right: 4px;
      }
      .hb-switch {
        width: 24px;
        height: 13px;
        background: rgba(255, 255, 255, 0.7);
        .hb-switch__slider {
          width: 11px;
          height: 11px;
          margin: 0 11px 0 0;
        }
        &.hb-switch-on {
          background-color: #3366CA;
          .hb-switch__slider {
            margin: 0 0 0 11px;
          }
        }
      }
    }
  }
  .main-category-container {
    margin: 20px 14px 0;
    border-radius: 2px;
    overflow: hidden;
    background: #131415;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 30px;
    position: relative;
    &::after {
      content: '';
      display: absolute;
      height: 200%;
      width: 200%;
      border-radius: 4px;
      position: absolute;
      left: 0;
      top: 0;
      box-sizing: border-box;
      border: 1px solid #64696e;
      transform: scale(0.5);
      transform-origin: top left;
      pointer-events: none;
    }
    .main-category-item {
      flex: 1;
      width: 0;
      color: #64696e;
      font-family: 'PingFang SC';
      font-size: 13px;
      font-weight: 400;
      line-height: 30px;
      text-align: center;
      position: relative;
      overflow: hidden;
      &:not(:last-child) {
        &::after {
          content: '';
          position: absolute;
          top: 0;
          right: -0.5px;
          width: 1px;
          height: 100%;
          background: #64696e;
          transform: scaleX(0.5);
        }
      }
      &.active {
        background: #e0e0e0;
        color: #131415;
        font-weight: 500;
      }
    }
  }
  .category-container {
    margin-top: 20px;
    padding: 0 14px;
  }
  .screenshot-wrapper {
    position: fixed;
    top: 0;
    left: 50vw;
    width: 375px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background:
      url('https://imgheybox.max-c.com/oa/2024/11/07/c1e95691d27284da063a96d95dd69c1a.png')
        no-repeat center / auto 85%,
      #000;
    z-index: 10000;
    transform: translate(-50%, 0);
    .unite-icon {
      width: 160px;
      height: 37px;
      margin: 45px 0 0 -12px;
    }
    .title-wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      .icon {
        height: 22px;
        width: 15px;
        margin: 0 10px;
        &.right {
          transform: rotateY(180deg);
          transform-origin: center;
        }
      }
      .text {
        font-family: 'Gellix', 'Alibaba PuHuiTi 1000';
        font-size: 40px;
        font-weight: 900;
        line-height: 56px;
        text-align: center;
        position: relative;
        top: -3px;
        margin-bottom: -3px;
      }
    }
    .subtitle-wrapper {
      margin-top: 20px;
      height: 24px;
      color: rgba(255, 255, 255, 0.8);
      font-family: 'Alibaba PuHuiTi 2.0';
      font-size: 14px;
      font-weight: 400;
      span {
        margin: 0 8px;
        color: #f2a366;
        font-family: 'Alibaba PuHuiTi 2.0';
        font-size: 17px;
        font-weight: 700;
        letter-spacing: 0.5px;
      }
    }
    .selected-game-wrapper {
      margin-top: 8px;
      width: 105px;
      border-radius: 3px;
      box-shadow: 0px 0px 10px 0px rgba(255, 255, 255, 0.35);
      .game-outer-box {
        width: 100%;
        position: relative;
        .game-inner-box {
          width: 100%;
          height: 100%;
          border: 1px solid #3366ca;
          display: flex;
          flex-direction: column;
          border-radius: 3px 3px 0 0;
          overflow: hidden;
          z-index: 1;
          .game-image {
            width: 100%;
            padding-top: 150.96154%;
            position: relative;
            .image {
              width: 100%;
              height: 100%;
              display: block;
              position: absolute;
              top: 0;
              left: 0;
              object-fit: cover;
            }
          }
        }
      }
      .game-name {
        width: 100%;
        height: 28px;
        border-radius: 0 0 3px 3px;
        background: #3366ca;
        padding: 0 8px;
        color: #fff;
        font-family: 'PingFang SC';
        font-size: 12px;
        font-weight: 500;
        line-height: 28px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
      }
    }
    .rule-desc {
      margin-top: 26px;
      color: rgba(255, 255, 255, 0.6);
      text-align: center;
      font-family: 'Alibaba PuHuiTi 2.0';
      font-size: 11px;
      font-weight: 400;
      line-height: 17px;
      letter-spacing: 0.5px;
      span {
        color: #377bff;
        font-family: 'Alibaba PuHuiTi 2.0';
        font-size: 11px;
        font-weight: 800;
        line-height: 17px;
      }
    }
    .footer-search {
      height: 54px;
    }
  }
}

.rule-modal {
  .rule-wrapper {
    padding: 22px 0 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .rule-title {
      color: #e0e0e0;
      font-family: 'PingFang SC';
      font-size: 16px;
      line-height: 22px;
    }
    .rule-list {
      margin-top: 8px;
      width: 100%;
      .rule-item {
        color: rgba(255, 255, 255, 0.6);
        font-family: 'PingFang SC';
        font-size: 12px;
        font-weight: 300;
        line-height: 20px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        .rule-index {
          flex-shrink: 0;
          min-width: 16px;
          text-align: center;
        }
        .rule-content {
          margin-left: 2px;
          flex: 1;
          width: 0;
          text-align: left;
        }
      }
    }
  }
}

.vote-modal {
  .hb-modal {
    height: 80vh;
    .hb-modal__body {
      height: calc(100% - 88px);
    }
  }
  .vote-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    .vote-header {
      width: 100%;
      padding: 18px 6px 8px;
      display: flex;
      flex-direction: column;
      position: relative;
      flex-shrink: 0;
      .btn-close {
        width: 20px;
        height: 20px;
        position: absolute;
        right: 8px;
        top: 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        i {
          font-size: 16px;
          color: #e0e0e0;
        }
      }
      .title {
        height: 25px;
        line-height: 25px;
        font-size: 18px;
        color: #e0e0e0;
      }
      .sub-title {
        width: calc(100% - 55px);
        line-height: 20px;
        font-size: 12px;
        color: #64696e;
        margin-top: 2px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .desc {
        height: 16px;
        line-height: 16px;
        font-size: 12px;
        color: #8c9196;
        margin-top: 12px;
      }
    }
    .vote-content {
      flex: 1;
      // height: 0;
      width: 100%;
      max-height: 60vh;
      position: relative;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      .content-scroll-wrapper {
        width: 100%;
        // height: 0;
        flex: 1;
        overflow-x: hidden;
        overflow-y: scroll;
        padding: 0 6px;
        &::-webkit-scrollbar {
          display: none;
        }
        .game-list {
          margin-right: -12px;
          display: flex;
          align-items: stretch;
          flex-direction: row;
          flex-wrap: wrap;
        }
        .game-list-bottom {
          width: 100%;
          height: 83px;
        }
      }

      .bottom-mask {
        height: 100px;
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        background: linear-gradient(
          180deg,
          rgba(27, 30, 33, 0) 0%,
          rgba(27, 30, 33, 0.8) 50%,
          #1b1e21 100%
        );
        z-index: 10;
        pointer-events: none;
      }
    }
  }

  .vote-btn {
    width: 100%;
    height: 44px;
    line-height: 44px;
    background: #3366ca;
    text-align: center;
    font-size: 16px;
    color: #fff;
    font-weight: 500;
    border-radius: 5px;
    color: #fff;
    &.disable {
      background-color: #232425;
      color: #8c9196;
      font-weight: 400;
    }
  }
}

.result-modal {
  .hb-modal {
    height: 80vh;
    .hb-modal__body {
      height: calc(100% - 88px);
    }
  }
  .result-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    .result-header {
      width: 100%;
      padding: 18px 6px 8px;
      display: flex;
      flex-direction: column;
      position: relative;
      flex-shrink: 0;
      .btn-close {
        width: 20px;
        height: 20px;
        position: absolute;
        right: 8px;
        top: 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        i {
          font-size: 16px;
          color: #e0e0e0;
        }
      }
      .title {
        height: 25px;
        line-height: 25px;
        font-size: 18px;
        color: #e0e0e0;
      }
      .sub-title {
        width: calc(100% - 55px);
        line-height: 20px;
        font-size: 12px;
        color: #64696e;
        margin-top: 2px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .desc {
        height: 16px;
        line-height: 16px;
        font-size: 12px;
        color: #8c9196;
        margin-top: 12px;
      }
    }
    .result-content {
      flex: 1;
      // height: 0;
      width: 100%;
      max-height: 60vh;
      position: relative;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      .content-scroll-wrapper {
        width: 100%;
        height: 0;
        flex: 1;
        overflow-x: hidden;
        overflow-y: scroll;
        padding: 0 6px;
        &::-webkit-scrollbar {
          display: none;
        }
        .subtitle {
          margin-top: 20px;
          color: #e0e0e0;
          font-family: 'PingFang SC';
          font-size: 13px;
          font-weight: 500;
          line-height: 18px;
        }
        .game-list {
          margin: 8px -12px 0 0;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          align-items: stretch;
        }
        .game-list-bottom {
          width: 100%;
          height: 83px;
        }
      }

      .bottom-mask {
        height: 100px;
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        background: linear-gradient(
          180deg,
          rgba(27, 30, 33, 0) 0%,
          rgba(27, 30, 33, 0.8) 50%,
          #1b1e21 100%
        );
        z-index: 10;
        pointer-events: none;
      }
    }
  }

  .chat-btn {
    width: 100%;
    height: 44px;
    line-height: 44px;
    background: #2d7d46;
    text-align: center;
    font-size: 16px;
    color: #fff;
    font-weight: 500;
    border-radius: 5px;
    color: #fff;
  }
}

.vote-dialog,
.chat-dialog {
  .hb-dialog {
    border-radius: 12px;
    background: #1d1e20;
    .hb-dialog__title {
      color: #fff;
      font-family: 'PingFang SC';
      font-size: 18px;
      font-weight: 500;
      line-height: 26px;
    }
    .hb-dialog__body {
      margin-top: 16px;
      color: #c8cdd2;
      font-family: 'PingFang SC';
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: 23px; /* 153.333% */
    }
    .hb-dialog__footer {
      margin-top: 20px;
      .hb-button {
        height: 42px;
        .text {
          font-family: 'PingFang SC';
          font-size: 14px;
          font-weight: 500;
        }
        &::before {
          display: none;
        }
      }
      .hb-button-cancel {
        background: #2e3133;
        .text {
          color: rgba(255, 255, 255, 0.3);
        }
      }
      .hb-button-confirm {
        background: #3366ca;
        .text {
          color: #fff;
        }
      }
      .hb-button-chat {
        background: #2d7d46;
        .text {
          color: #fff;
        }
      }
    }
  }
}
</style>
